import React from "react";
import { useViewContent } from "@/lib/pixel";
import { Link } from "react-router-dom";
import { PageHero, Reveal, Overline } from "@/components/primitives";
import { CtaStrip } from "@/components/sections";
import { AGENDA_DAY1, AGENDA_DAY2 } from "@/data/site";

function DayTable({ day, date, rows }) {
  return (
    <Reveal>
      <div className="overflow-hidden rounded-3xl border border-border bg-white shadow-sm">
        <div className="flex items-baseline justify-between gap-3 border-b border-border bg-navy px-6 py-5">
          <h3 className="font-display text-xl font-bold text-white">{day}</h3>
          <span className="text-sm font-medium text-emerald-300">{date}</span>
        </div>
        <div className="divide-y divide-border">
          {rows.map((r, i) => (
            <div key={i} className="grid grid-cols-12 items-center gap-3 px-6 py-4 transition-colors hover:bg-parchment">
              <span className="col-span-3 font-display text-sm font-bold text-emeraldDeep sm:col-span-2">{r.time}</span>
              <div className="col-span-9 sm:col-span-10">
                <p className="font-semibold text-navy">{r.session}</p>
                {r.focus && <p className="text-sm text-navy/60">{r.focus}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  );
}

export default function Agenda() {
  useViewContent("Agenda");
  return (
    <>
      <PageHero
        overline="Agenda"
        title="Two days. The full ethanol agenda."
        subtitle="Programme subject to refinement — confirmed session times below."
      >
        <nav className="text-sm text-slate-400">
          <Link to="/" className="hover:text-white">Home</Link> <span className="text-slate-600">›</span>{" "}
          <Link to="/conference" className="hover:text-white">Conference</Link> <span className="text-slate-600">›</span>{" "}
          <span className="text-emerald-300">Agenda</span>
        </nav>
      </PageHero>

      <section className="bg-parchment py-20 md:py-28">
        <div className="mx-auto max-w-7xl space-y-10 px-6 md:px-12">
          <DayTable day="Day 1" date="28 September 2026" rows={AGENDA_DAY1} />
          <DayTable day="Day 2" date="29 September 2026" rows={AGENDA_DAY2} />
        </div>
      </section>

      <CtaStrip title="Reserve your seat for both days." />
    </>
  );
}
